import { useCallback, useState } from "react";
import { Button, UploadIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useDropzone } from "react-dropzone";
import { useQueryClient } from "react-query";
import { useUploadLocaleStrings } from "../../hooks/localestrings/useUploadLocaleStrings";

type LocaleStringsUploaddButtonProps = {
    productCode: string; 
    cultureCode: string | undefined;
    refetch: () => void
  };

  
export const LocaleStringsUploadButton: React.FC<LocaleStringsUploaddButtonProps> = ({
    productCode,
    cultureCode,
    refetch
}) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  const { uploadLocaleStrings } = useUploadLocaleStrings(productCode, cultureCode);

  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      setIsLoading(true);
      for (const file of acceptedFiles) {
        try {
          await uploadLocaleStrings(file);
          refetch()
        } catch (error) {}
        queryClient.invalidateQueries("uploadLocaleStrings");
      }
      setIsLoading(false);
    },
    [uploadLocaleStrings, queryClient]
  );

  const { getInputProps, open } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true,
  });

  return (
    <>
      <input {...getInputProps()} />

      <Button
        disabled={cultureCode == undefined}
        key="localestrings-upload"
        type="primary"
        icon={<UploadIcon />}
        onClick={() => {
          open();
        }}
        loading={isLoading}
      >
        {t("localestrings.actions.upload.button")}
      </Button>
    </>
  );
};
